import MinimizableModal from './bobjectForm.container';

export default MinimizableModal;
